//大小寫需一致
const zh_TW = {
  // 'app.learn': '學習 {name}'
  // , "app.Salmon": "{name} 鮭魚"
  // , "app.loginMessage": "請輸入您的帳號、密碼"
  // , "app.screenLockMessage": "請輸入您的密碼"
  // //UserInfo
  // , "app.screenLock": "螢幕鎖定"
  // , "app.loginMessage_Error": "帳號或密碼錯誤"
  // , "app.PasswordNotMatch": "新密碼不一致"
  // , "passwordOld": "舊密碼"
  // , "passwordNew": "新密碼"
  // , "passwordConfirm": "新密碼確認"
  // , "app.changePw": "變更密碼"
  "app.LoginButton": "登 錄"
  , "UserName": "姓名"
  , "birthDate": "出生日期"
  , "personalId": "身分證字號"
  , "app.Clear": "清除"
  , "請填寫這個欄位。": "請填寫這個欄位。"
  , "請符合要求的格式。": "請符合要求的格式。"
  , "app.LoginCantFound": "抱歉,查無您的預約資料\r\n請致電 04-2255-2555 #168 企業健檢預約查詢"
  , "app.AllQuestsDone": "您所需要填寫的問卷均已提交，謝謝"
  , "app.FillNextTime": "重新填寫"
  , "app.Logout": "登出"
  , "app.Next": "下一份"
  , "app.Back": "上一份"
  , "app.Done": "完成"
  , "app.QuestsNotYet": "當前問卷尚未完成，請先點擊底下的\"提交\"送出當前問卷"
  , "app.ThankWords": "感謝您的耐心填寫"
  , "app.ThankDone": "全部已完成"
  , "app.Submit": "提 交"
  , "app.Cancel": "關閉"
  , "尚有問題未完成": "尚有問題未完成"
  , "填寫此欄位": "填寫此欄位"
  , "選擇其中一個選項": "選擇其中一個選項"
  , "勾選此註記框": "勾選此註記框"
  , "輸入數字": "輸入數字"
  , "app.pleaseSelect": "請選擇..."

  //問卷所寫
  , "心血管": "心血管"
  , "肌肉骨骼": "肌肉骨骼"
  , "心情量表": "心情量表"
  , "過勞評估": "過勞評估"
  , "勞檢問卷": "勞檢問卷"
  , "無紙化": "無紙化"
  //70
  , "十年心血管風險評估": "十年心血管風險評估"
  , "填寫前說明": "填寫前說明"
  , "基本資料": "基本資料"
  , "體檢後": "體檢後"
  , "你有沒有吸煙": "你有沒有吸煙"
  , "你有沒有服用高血壓藥物": "你有沒有服用高血壓藥物"
  , "你有沒有糖尿病史": "你有沒有糖尿病史"
  , "沒有": "沒有"
  , "有吸煙": "有吸煙"
  , "有服用高血壓藥物": "有服用高血壓藥物"
  , "有糖尿病史": "有糖尿病史"
  , "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。": "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。"
  , "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]": "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]"

  //無紙化
  , "app.NopaperComfirm": "之前已確認使用無紙化服務，感謝與您一同保護地球！"
  , "app.NopaperNoexit": "查無客戶資料，請確認"
  , "健檢報告無紙化服務同意書": "健檢報告無紙化服務同意書"
  , "支持 ": "支持 "
  , "晨悅診所響應環保、節能愛地球": "晨悅診所響應環保、節能愛地球"
  , "之活動，": "之活動，"
  , "同意": "同意"
  , " 晨悅診所將本人健康檢查報告，": " 晨悅診所將本人健康檢查報告，"
  , "完成後以email方式通知至本人指定之電子信箱": "完成後以email方式通知至本人指定之電子信箱"
  , "，資料如下": "，資料如下"
  , "立書同意人：": "立書同意人："
  , "身分證字號：": "身分證字號："
  , "E-mail:   (用於通知報告完成，請您確認正確)": "E-mail:   (用於通知報告完成，請您確認正確)"
  , "立書同意人：": "立書同意人："
  , "簽名時間：": "簽名時間："
  , "Email確認正確": "Email確認正確"
  , "點擊按鈕才算完成": "點擊按鈕才算完成"
  , "謝謝": "謝謝！請按右上角的下一份繼續"

  //sign
  , "簽名": "簽名"
  , "重新簽名": "重新簽名"
  , "確認": "確認"
  , "請簽名(行動裝置請旋轉螢幕為水平橫向)...": "請簽名(行動裝置請旋轉螢幕為水平橫向)..."
  //肌肉骨骼
  , "肌肉骨骼症狀調查表": "肌肉骨骼症狀調查表"
  , "痠痛症狀調查": "痠痛症狀調查"
  , "其他症狀、病史說明": "其他症狀、病史說明"
  , "右腳踝/右腳": "右腳踝/右腳"
  , "左腳踝/左腳": "左腳踝/左腳"
  , "右膝": "右膝"
  , "左膝": "左膝"
  , "右臀/右大腿": "右臀/右大腿"
  , "左臀/左大腿": "左臀/左大腿"
  , "右手/右手腕": "右手/右手腕"
  , "左手/左手腕": "左手/左手腕"
  , "右手肘/右前臂": "右手肘/右前臂"
  , "左手肘/左前臂": "左手肘/左前臂"
  , "右肩部": "右肩部"
  , "左肩部": "左肩部"
  , "下背部": "下背部"
  , "上背部": "上背部"
  , "頸部": "頸部"
  , "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』": "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』"
  , "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？": "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？"
  , "您平常使用電腦、滑鼠慣用手為？": "您平常使用電腦、滑鼠慣用手為？"
  , " 左手": " 左手"
  , " 右手": " 右手"
  , "是（若是，請繼續填寫下列表格。）": "是（若是，請繼續填寫下列表格。）"
  , "否（若否，結束此調查表）": "否（若否，結束此調查表）"
  , "1個月": "1個月"
  , "3個月": "3個月"
  , "6個月": "6個月"
  , "1年": "1年"
  , "3年": "3年"
  , "3年以上": "3年以上"
  , "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。": "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。"
  , "酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答": "酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答"
  , "不痛": "不痛"
  , "痛可忽略": "痛可忽略"
  , "可能影響工作": "可能影響工作"
  , "影響工作": "影響工作"
  , "影響自主活動功能": "影響自主活動功能"
  , "完全無法自主活動": "完全無法自主活動"
  , "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？": "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？"





  , "晨悅預防醫學": "晨悅預防醫學"
  , "健康人生，攜手晨悅": "健康人生，攜手晨悅"
  , "請選取其中一個選項。": "請選取其中一個選項。"

  //心情量表
  , "計分方式": "計分方式"
  , "沒有或極少": "沒有或極少"
  , "有時候": "有時候"
  , "時常": "時常"
  , "常常或總是": "常常或總是"
  , "我常常覺得想哭": "我常常覺得想哭"
  , "我覺得心情不好": "我覺得心情不好"
  , "我覺得比以前容易發脾氣": "我覺得比以前容易發脾氣"
  , "我睡不好": "我睡不好"
  , "我覺得不想吃東西": "我覺得不想吃東西"
  , "我覺得胸口悶悶的": "我覺得胸口悶悶的"
  , "我覺得不輕鬆、不舒服": "我覺得不輕鬆、不舒服"
  , "我覺得身體疲勞虛弱無力": "我覺得身體疲勞虛弱無力"
  , "我覺得很煩": "我覺得很煩"
  , "我覺得記憶力不好": "我覺得記憶力不好"
  , "我覺得做事時無法專心": "我覺得做事時無法專心"
  , "我覺得想事情或做事時比平常要緩慢": "我覺得想事情或做事時比平常要緩慢"
  , "我覺得比以前沒信心": "我覺得比以前沒信心"
  , "我覺得比較會往壞處想": "我覺得比較會往壞處想"
  , "我覺得想不開，甚至想死": "我覺得想不開，甚至想死"
  , "我覺得對什麼事都失去興趣": "我覺得對什麼事都失去興趣"
  , "我覺得身體不舒服": "我覺得身體不舒服"
  , "我覺得自己很沒用": "我覺得自己很沒用"
  , "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分": "『沒有或極少』0分；『有時候』1分；『時常』2分；『常常或總是』3分"
  , "8 分以下---情緒穩定": "8 分以下---情緒穩定"
  , "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心": "9~14分---情緒較不穩定、多注意情緒變化，多給自己關心"
  , "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒": "15~18分---壓力負荷已到極點，需要找朋友交談、舒緩情緒"
  , "19分以上---必須找專業醫療單位協助": "19分以上---必須找專業醫療單位協助"
  , "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週": "說明：本量表所列舉的問題是為協助您瞭解您的心情狀況，請您仔細回想在一星期中，這些問題發生幾天，然後圈選一個您認為最能代表您感覺的答案。『沒有或極少』1天以下/週，『有時候』1~2天/週，『時常』3~4天/週，『常常或總是』5~7天/週"

  //過勞評估量表
  , "過勞評估量表": "過勞評估量表"
  , "個人疲勞": "個人疲勞"
  , "工作疲勞": "工作疲勞"
  , "分數解釋": "分數解釋"
  , "個人相關過勞": "個人相關過勞"
  , "50 分以下": "50 分以下"
  , "輕微": "輕微"
  , "您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。": "您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。"
  , "50－70 分": "50－70 分"
  , "中度": "中度"
  , "你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。": "你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。"
  , "70 分以上": "70 分以上"
  , "嚴重": "嚴重"
  , "您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。": "您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"
  , "工作相關過勞": "工作相關過勞"
  , "45 分以下": "45 分以下"
  , "您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。": "您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。"
  , "45－60 分": "45－60 分"
  , "您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。": "您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。"
  , "60 分以上": "60 分以上"
  , "您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。": "您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"
  , "你常覺得疲勞嗎?": "你常覺得疲勞嗎?"
  , "你常覺得身體上體力透支嗎?": "你常覺得身體上體力透支嗎?"
  , "你常覺得情緒上心力交瘁嗎?": "你常覺得情緒上心力交瘁嗎?"
  , "你常會覺得，「我快要撐不下去了」嗎?": "你常會覺得，「我快要撐不下去了」嗎?"
  , "你常覺得精疲力竭嗎?": "你常覺得精疲力竭嗎?"
  , "你常常覺得虛弱，好像快要生病了嗎?": "你常常覺得虛弱，好像快要生病了嗎?"
  , "你的工作會令人情緒上心力交瘁嗎？": "你的工作會令人情緒上心力交瘁嗎？"
  , "你的工作會讓你覺得快要累垮了嗎?": "你的工作會讓你覺得快要累垮了嗎?"
  , "你的工作會讓你覺得挫折嗎?": "你的工作會讓你覺得挫折嗎?"
  , "工作一整天之後，你覺得精疲力竭嗎?": "工作一整天之後，你覺得精疲力竭嗎?"
  , "上班之前只要想到又要工作一整天，你就覺得沒力嗎?": "上班之前只要想到又要工作一整天，你就覺得沒力嗎?"
  , "上班時你會覺得每一刻都很難熬嗎?": "上班時你會覺得每一刻都很難熬嗎?"
  , "不工作的時候，你有足夠的精力陪朋友或家人嗎?": "不工作的時候，你有足夠的精力陪朋友或家人嗎?"
  , "總是": "總是"
  , "常常": "常常"
  , "不常": "不常"
  , "從未或幾乎從未": "從未或幾乎從未"
  , "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。": "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。"
  , "有一些": "有一些"
  , "很嚴重": "很嚴重"
  , "非常輕微": "非常輕微"
  //勞工體(健)檢問卷
  , "勞工體(健)檢問卷": "勞工體(健)檢問卷"
  , "一、作業經歷：": "一、作業經歷："
  , "1.曾經從事": "1.曾經從事"
  , "起始日期:": "起始日期:"
  , "截止日期:": "截止日期:"
  , "2.目前從事": "2.目前從事"
  , "3.過去 1 個月，平均每週工時為：": "3.過去 1 個月，平均每週工時為："
  , "小時": "小時"
  , "；過去 6 個月，平均每週工時為：": "；過去 6 個月，平均每週工時為："
  , "新進員工": "新進員工"
  , "定期檢查": "定期檢查"
  , "二、檢查時期（原因）：": "二、檢查時期（原因）："
  , "四、既往病史：": "四、既往病史："
  , "您是否曾患有下列慢性疾病：（請在適當項目前打勾）": "您是否曾患有下列慢性疾病：（請在適當項目前打勾）"
  , "以上皆無": "以上皆無"
  , "骨折": "骨折"
  , "其他慢性病": "其他慢性病"
  , "手術開刀": "手術開刀"
  , "癌症": "癌症"
  , "逆流性食道炎": "逆流性食道炎"
  , "消化性潰瘍、胃炎": "消化性潰瘍、胃炎"
  , "甲狀腺疾病": "甲狀腺疾病"
  , "聽力障礙": "聽力障礙"
  , "中耳炎": "中耳炎"
  , "貧血": "貧血"
  , "肝病": "肝病"
  , "腎臟病": "腎臟病"
  , "肺結核": "肺結核"
  , "慢性氣管炎、肺氣腫": "慢性氣管炎、肺氣腫"
  , "氣喘": "氣喘"
  , "癲癇": "癲癇"
  , "中風": "中風"
  , "白內障": "白內障"
  , "心臟病": "心臟病"
  , "糖尿病": "糖尿病"
  , "高血壓": "高血壓"
  , "五、生活習慣：": "五、生活習慣："
  , "1.請問您過去一個月內是否有吸菸？": "1.請問您過去一個月內是否有吸菸？"
  , "從未吸菸": "從未吸菸"
  , "偶爾吸(不是天天)": "偶爾吸(不是天天)"
  , "幾乎)每天吸": "幾乎)每天吸"
  , "已經戒菸，戒了": "已經戒菸，戒了"
  , "平均每天吸": "平均每天吸"
  , "支": "支"
  , "已吸菸": "已吸菸"
  , "2.請問您最近六個月內是否有嚼食檳榔？": "2.請問您最近六個月內是否有嚼食檳榔？"
  , "從未嚼食檳榔": "從未嚼食檳榔"
  , "偶爾嚼(不是天天)": "偶爾嚼(不是天天)"
  , "(幾乎)每天嚼": "(幾乎)每天嚼"
  , "已經戒食，戒了": "已經戒食，戒了"
  , "平均每天嚼": "平均每天嚼"
  , "已嚼 ": "已嚼 "
  , "3.請問您過去一個月內是否有喝酒？": "3.請問您過去一個月內是否有喝酒？"
  , "從未喝酒": "從未喝酒"
  , "偶爾喝(不是天天)": "偶爾喝(不是天天)"
  , "（幾乎）每天喝": "（幾乎）每天喝"
  , "已經戒酒，戒了": "已經戒酒，戒了"
  , "平均每週喝": "平均每週喝"
  , "最常喝 ": "最常喝 "
  , "酒": "酒"
  , "每次 ": "每次"
  , "瓶": "瓶"
  , "4.請問您於工作日期間，平均每天睡眠時間為：": "4.請問您於工作日期間，平均每天睡眠時間為："
  , "六、自覺症狀：": "六、自覺症狀："
  , "三、關係人": "三、關係人"
  , "您最近三個月是否常有下列症狀：（請在適當項目前打勾）": "您最近三個月是否常有下列症狀：（請在適當項目前打勾）"
  , "咳嗽": "咳嗽"
  , "咳痰": "咳痰"
  , "呼吸困難": "呼吸困難"
  , "胸痛": "胸痛"
  , "心悸": "心悸"
  , "頭暈": "頭暈"
  , "頭痛": "頭痛"
  , "耳鳴": "耳鳴"
  , "倦怠": "倦怠"
  , "噁心": "噁心"
  , "腹痛": "腹痛"
  , "便秘": "便秘"
  , "腹瀉": "腹瀉"
  , "血便": "血便"
  , "上背痛": "上背痛"
  , "下背痛": "下背痛"
  , "手腳麻痛": "手腳麻痛"
  , "關節疼痛": "關節疼痛"
  , "排尿不適": "排尿不適"
  , "多尿、頻尿": "多尿、頻尿"
  , "手腳肌肉無力": "手腳肌肉無力"
  , "體重減輕 3公斤以上": "體重減輕 3公斤以上"
  , "其他症狀": "其他症狀"
  , "年": "年"
  , "個月": "個月"
  , "次": "次"
  , "顆": "顆"
  , "共": "共"

  , "update success": "更新成功"
  , "update fail": "更新失敗"
  , "如果你要繼續執行，請勾選這個核取方塊。": "如果你要繼續執行，請勾選這個核取方塊。"


  // , "app.Languages": "語言"
  // , "app.Colors": "顏色"
  // , "app.pleaseSelect": "請選擇..."
  // , "app.add": "新增"
  // , "app.addPlus": "新增+"
  // , "app.sendCheck": "送審"
  // , "app.delete": "刪除"
  // , "app.Edit": "編輯"
  // , "app.Undelete": "反刪除"
  // , "app.Audit": "審核"
  // , "app.UnAudit": "反審核"
  // , "app.Cancel": "取消"
  // , "app.Submit": "上傳"
  // , "app.isDelete": "確認是否刪除?"
  // , "app.UploadYourFile": "請上傳檔案..."
  // , "app.administrator": "管理員無法被修改"
  // , "app.haveData": "尚有明細無法刪除"
  // , "app.Query": "查詢"
  // , "app.CloseAll": "關閉所有"
  // , "app.CloseOthers": "關閉其他"

  // // helperText for Validator
  // , "noRepeat": "不可重複"
  // , "required": "必填"
  // , "minLength": "最小長度"
  // , "maxLength": "最大長度"
  // //EmployeeTable
  // , "EmployeeTable": "員工列表"
  // , "empName": "姓名"
  // , "empAddress": "地址"
  // , "pensionRate": "退休金率"
  // , "seniorityY": "年資(Y)"
  // , "seniorityM": "年資(M)"
  // , "seniorityMTotal": "總年資(M)"
  // , "empPhone": "電話"
  // , "companyId": "公司"
  // , "companyName": "公司"
  // , "empSID": "身分證號"
  // , "empAccount": "帳號"
  // , "email": "email"
  // , "gender": "性別"
  // , "genderText": "性別"
  // , "dateBirth": "生日"
  // , "dateQuit": "離職日"
  // , "dateHire": "僱用日"
  // , "dateCreate": "資料創建日"
  // , "EmployeeWageStructureTable": "員工薪資結構表"
  // , "WageAmount": "金額"
  // , "DataAdd": "建立時間"
  // , "ExemptClock": "需要打卡"
  // , "ExemptClockText": "需要打卡"
  // //CompanyTable
  // , "CompanyTable": "公司列表"
  // , "companyName": "公司名稱"
  // , "taxNumber": "稅號"
  // , "address": "地址"
  // , "prefixTitle": "前綴"
  // , "ZipCode": "郵編"
  // ////ShiftsTable
  // , "ShiftsTable": "班別設定"
  // , "sqShifts": "班別名稱"
  // , "shiftsName": "班別名稱"
  // , "WorkTimeStart": "上班時間"
  // , "WorkTimeEnd": "下班時間"
  // , "RestTimeStart": "休息開始"
  // , "RestTimeEnd": "休息開始"
  // , "workhours": "工時"
  // //WageTypeTable
  // , "WageTypeTable": "薪資類型表"
  // , "name": "名稱"
  // , "kind": "類型"
  // , "DateAdd": "新增日期"
  // , "currencyId": "幣別"
  // , "amount": "金額"
  // , "wageStructure": "薪資結構"
  // , "wageHistory": "歷史薪資"
  // //empInsurance
  // , "EmpInsuranceTitle": "勞健保級距列表"
  // , "subSq": "No."
  // , "salaryRank": "薪水級距"
  // , "labourInsurance": "勞保(個人)"
  // , "labourInsuranceEntity": "勞保(企業)"
  // , "healthCare": "健保(個人)"
  // , "healthCareEntity": "健保(企業)"
  // , "year": "Year"
  // , "DateFrom": "起始日"
  // , "DateTo": "結束日"
  // , "local": "區域"
  // //LeaveTypeContainer
  // , "LeaveTypeContainer": "請假類別設定"
  // , "payRatio": "支付比例"
  // //LeaveApplicationContainer
  // , "LeaveApplicationContainer": "請假類單申請"
  // , "sqLeaveType": "假別類別"
  // , "LeaveTypeName": "假別類別"
  // , "empId_applicant": "申請人"
  // , "LeaveApplicantName": "申請人"
  // , "empId_substitute": "代理人"
  // , "LeaveSubstituteName": "代理人"
  // , "dateFrom": "起始日期"
  // , "dateTo": "結束日期"
  // , "hours": "請假時數"
  // , "checkType": "簽核狀態"
  // , "CheckTypeName": "簽核狀態"
  // , "leaveDescription": "說明"
  // //LeaveApplicationCheckContainer
  // , "LeaveApplicationCheckContainer": "請假類單審核"
  // //roles
  // , "RolesSetting": "角色設定"
  // , "rolesName": "角色名稱"
  // //Attendance
  // , "AttendanceUploadTitle": "出勤上傳"
  // , "isUpload": "是否上傳"
  // , "AttendanceRecordTitle": "出勤紀錄"
  // , "everyday": "日期"
  // , "AttendanceStatus": "出勤狀況"
  // , "isWorkday": "上班日"
  // , "clockDate": "打卡日期"
  // , "startTime": "上班打卡時間"
  // , "endTime": "下班打卡時間"
  // , "manualStartTime": "手動上班時間"
  // , "manualEndTime": "手動下班時間"
  // //AttendanceAdjust
  // , "AttendanceAdjustEmpTitle": "出勤人員"
  // , "PersonalAttendanceAdjustTitle": "出勤時數"
  // , "WorkOwedHours": "積欠小時"
  // , "WorkOverTime": "加班小時"
  // , "manualWorkOwedHours": "修正請假時數"
  // , "manualWorkOverTime": "修正加班時數"
  // , "AdjustConfirm": "調整確認"
  // , "AdjustDelete": "刪除調整"
  // , "AdjustTextNotConfirm": "未確認調整"
  // , "AdjustTextConfirmed": "確認調整時間:"
  // //WageCalculatorTable
  // , "WageCalculatorTitle": "薪資計算表"
  // , "BasicAmt": "薪資"
  // , "workOverTime133": "加班時數(一皆)"
  // , "workOverTime166": "加班時數(二皆)"
  // , "overtimeExpenses": "加班費"
  // , "workOwedTime": "請假/遲到時數"
  // , "owedExpenses": "請假/遲到扣薪"
  // , "totalSalary": "總薪資"
  // , "levelRank": "投保級距"
  // , "selfSaving": "員工自提"
  // , "pensionEntity": "退休金"
  // , "actualSalary": "實付薪資"
  // , "actualSalaryWithBonus": "實付薪資(含獎金)"
  // , "manualBonus01": "獎金(一)"
  // , "manualBonus02": "獎金(二)"
  // , "manualBonus03": "獎金(三)"
  // , "setAllmanualBonus01": "設定全獎金(一)"
  // , "setAllmanualBonus02": "設定全獎金(二)"
  // , "setAllmanualBonus03": "設定全獎金(三)"
  // //JobsType
  // , "sqJobsType": "NO."
  // , "JobsTypeName": "工作性質"
  // //CalendarTable
  // , "holidayDescription": "描述"
  // , "multiplierRate": "係數"
  // , "DateRest": "日期"

  , "UserName": "姓名"
  , "checkdate": "體檢日期"
  , "barcode": "條碼號"
  , "PersonalId": "身分證號"
  , "UpdateCount": "更新次數"
  , "app.FrozenColumn": "凍結欄位"
  , "app.ColumnCount": "欄位數"
  , "app.ShowColumn": "顯示欄位"

  //BigCalendar
  , "start": "起始時間"
  , "end": "結束時間"
  , "resourceId": "會議室"
  , "title": "會議內容"
  , "department": "部門"
  , "app.CancelBooking": "取消預約"

  //WeeklyBooking
  , "SOMEDAY": "預約日期"
  , "RANGETIME": "時段"
  , "Limit": "限額"
  , "DY": "到院"
  , "CW": "腸胃"
  , "AMQC": "AM企檢"
  , "PMQC": "PM企檢"
  , "AMGC": "AM個檢"
  , "PMGC": "PM個檢"
  , "AMBC": "AM補檢"
  , "PMBC": "PM補檢"
  , "FL": "防老"
  , "Hear": "聽力全頻"
  , "Ultra": "心超"
  , "Lung": "肺功能"
  , "Auto": "全自動"
  , "DXA": "DXA"
  , "MP": "抹片"
  , "VIP": "VIP"
  , "VIPRest": "VIP餐廳"

  //WeeklyBooking
  , "BarCodeStr": "BarCodeStr"
  , "Name": "Name"
  , "ID": "ID"
  , "SpecNo66": "更新66"

  //80
  , "是否需要輪班?": "是否需要輪班?"
  , "Shift2": "兩班制"
  , "Shift3": "三班制"
  , "Shift4": "四班制"
  , "ShiftOther": "其他："
  , "Yes": "是"
  , "No": "否"
  , "Forgot": "忘記日期"
  , "NoJob": "無工作經驗"
  , "新勞檢測試": "勞檢"

};
export default zh_TW;